import { useDeleteCompanyLink as useDeleteCompanyLinkMutation } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH =
  'COMPANY_LINKS.COMPANY_LINK_CARD.COMPANY_LINK_ACTIONS.DELETE_COMPANY_LINK_CONFIRM_MODAL';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE';

type UseDeleteCompanyLinkReturnType = {
  handleDeleteCompanyLink: (linkId: string) => void;
};

export const useDeleteCompanyLink = (): UseDeleteCompanyLinkReturnType => {
  const { t } = useTranslation();

  const { showError, showSuccess } = useNotification();

  const { mutate: mutateDelete } = useDeleteCompanyLinkMutation();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const onConfirm = (linkId: string): void => {
    mutateDelete({ companyLinkId: linkId }, { onSuccess, onError });
  };

  const handleDeleteCompanyLink = (linkId: string): void => {
    if (!linkId) return;
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON'),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(linkId),
    });
  };

  return { handleDeleteCompanyLink };
};
